import React, { useCallback } from "react";
import styles from "./index.module.scss";
import AccordionItem from "components/common/AccordionItem";
import { useAppSelector } from "store/hooks";
import { getSettings } from "store/slices";
import { IQnA } from "types/lifeChoice";
import { t } from "i18next";
import { useLifeChoicePageContext } from "context/hooks/useLifeChoicePageContext";
import Label from "components/common/Label";

const QnA = () => {
  const { dir, language } = useAppSelector(getSettings);
  const {
    lifeChoice: { faq },
  } = useLifeChoicePageContext();
  const renderHeader = useCallback(
    ({ question }: IQnA) => (
      <h4 className="fw-500 text-primary-300">{question[language]}</h4>
    ),
    [language]
  );
  const renderBody = useCallback(
    ({ answer }: IQnA) => (
      <p dir={dir} lang={language} className="fw-500 text-primary-300">
        {answer[language]}
      </p>
    ),
    [language]
  );

  return (
    <div className={`${styles["qna"]} | container`} dir={dir} lang={language}>
      <Label>
        {t("qna") as string}
      </Label>
      <div className={`${styles["accordion-list"]} mt-2`}>
        {faq.map((item: any) => (
          <AccordionItem
            renderBody={renderBody}
            renderHeader={renderHeader}
            key={item._id}
            item={item}
            headerClassName={"justify-between cursor-pointer"}
          />
        ))}
      </div>
    </div>
  );
};

export default QnA;
